import React, { useState, useEffect, useReducer } from 'react'
import { Panel, Row, Col, Icon, Table } from 'rsuite'
import { budgetFormat } from '../../utils/formatterUtil'
import { sessionGetItemJSON } from '../../utils/sessionHelpers'
import notification from '../../utils/notification'
import { startLoading, doneLoading } from '../../utils/loading'
import { getReceivedFrom } from '../../redux/actions/incomeAndExpense'
import IncomeRecordFileTable from '../incomeRecordWidget/IncomeRecordFileTable'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import { downloadExpenseRequestAttachments } from '../../redux/actions/accountingExpenseRequest'
import { getDateThaiShort, getValueFromOptions } from '../../utils/dataUtil'

export default function AdvanceRefundView({
  schema: _schema,
  setIsEnableEdit = () => {},
  borrowAmont = 0,
  setBorrowAmont = () => {},
  payActive = '',
  setPayActive = () => {},
  accountingBorrowAvancesList = [],
  disabledForm = false,
  setDisabledForm = () => {},
  ...props
}) {
  const [formSchema, setFormSchema] = useState(_schema)
  const [accChannel, setAccChannel] = useState(_schema.accountChannel.value || '1')

  const [receiveMoneyEtcVal, setReceiveMoneyEtcVal] = useState(_schema.receiveMoneyEtc.value)
  const [receiveMoneyEtcId, setReceiveMoneyEtcId] = useState(_schema.receiveMoneyEtc.id)

  const [fileTableData, setFileTableData] = useState(_schema?.attachFiles?.values || [])
  const [isCancel, setIsCancel] = useState(false)

  const projectCode = sessionStorage.getItem('projectCode')
  const periodInfo = sessionGetItemJSON('periodInfo')
  const borrowId = sessionStorage.getItem('borrowId')

  const onDownload = async (fileObj) => {
    startLoading()
    try {
      var file = await downloadExpenseRequestAttachments(fileObj.id)
      var fileName = fileObj.label

      downloadFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
  }

  const onPreview = async (fileObj) => {
    startLoading()
    try {
      var file = await downloadExpenseRequestAttachments(fileObj.id)
      var fileName = fileObj.name

      previewFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'แสดง ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
  }

  const renderBorrowAdvance = (id) => {
    if (id) {
      let fullTitle = ''

      let obj = accountingBorrowAvancesList.find((i) => i.id == id)
      let date = new Date(obj.borrowerDate).toLocaleDateString('th-TH')
      fullTitle = obj.borrowerName + ' วันที่ยืม ' + date + ' เลขที่อ้างอิง ' + obj.documentNumber

      return fullTitle
    }
    return ''
  }

  return (
    <>
      <Panel
        bordered
        style={{
          marginTop: 25,
          border: '1px solid #4e4b488c',
        }}
        header={
          periodInfo && (
            <div style={{ textAlign: 'left' }}>
              <Col lg={12} md={12} sm={24} xs={24}>
                <span>{periodInfo?.periodNo + ' (' + periodInfo?.startAndEndDate + ')'}</span>
              </Col>
              <Col lg={12} md={12} sm={24} xs={24} style={{ textAlign: 'right' }}>
                <span>
                  {'งวดที่ ' + periodInfo?.periodNumber + '/' + periodInfo?.periodOfLength}
                </span>
              </Col>
            </div>
          )
        }
      >
        <Row style={{ marginTop: 30 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.voucherNumber.label}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <p>{` : ${formSchema.voucherNumber.value || ''}`}</p>
          </Col>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.receiveMoneyEtc.label}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <p>: {receiveMoneyEtcVal}</p>
          </Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.accountChannel.label}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <p>
              {` : ${getValueFromOptions(
                formSchema.accountChannel.options,
                formSchema.accountChannel.value || '1'
              )}`}
            </p>
          </Col>

          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.amountBorrowed.label}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <p>: {budgetFormat(borrowAmont)}</p>
          </Col>
        </Row>

        {accChannel == '2' && (
          <>
            <Row>
              <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                {formSchema.bankAccount.label}
              </Col>
              <Col lg={20} md={20} sm={24} xs={24}>
                <p>
                  {` : ${getValueFromOptions(
                    formSchema.bankAccount.options,
                    formSchema.bankAccount.value
                  )}`}
                </p>
              </Col>
            </Row>
          </>
        )}

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.listBorrowAdvance.label}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <p>{renderBorrowAdvance(formSchema?.listBorrowAdvance?.value)}</p>
          </Col>

          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.payActive.label}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <p>
              {` : ${getValueFromOptions(
                formSchema.payActive.options,
                formSchema.payActive.value
              )}`}
            </p>
          </Col>
        </Row>

        <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
          {formSchema.actureReturnDate.label}
        </Col>
        <Col lg={8} md={8} sm={24} xs={24}>
          {/* <p>{` : ${new Date(formSchema?.actureReturnDate?.value).toLocaleDateString('th-TH')}`}</p> */}
          <p>{formSchema?.actureReturnDate?.valueView}</p>
        </Col>

        {formSchema.cancelCheckBox && receiveMoneyEtcId && !borrowId && (
          <Row style={{ marginTop: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24} />
            <Col lg={20} md={20} sm={24} xs={24}>
              <Icon icon="check-circle" size="lg" />
              {` ${formSchema?.cancelCheckBox?.label}`}
            </Col>
          </Row>
        )}

        {formSchema.reason && isCancel && receiveMoneyEtcId && (
          <Row style={{ marginTop: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
              {formSchema.reason.label}
            </Col>
            <Col lg={20} md={20} sm={24} xs={24}>
              <p>{` :${formSchema.reason.value || ''}`}</p>
            </Col>
          </Row>
        )}

        <Row style={{ marginTop: 30 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.attachFiles.label || 'เอกสารแนบประกอบ'} {' : '}
          </Col>
          <Col lg={20} md={20} sm={24} xs={24}>
            {fileTableData.length > 0 && (
              <IncomeRecordFileTable
                data={fileTableData}
                deleteable={false}
                onPreview={onPreview}
                onDownload={onDownload}
              />
            )}
          </Col>
        </Row>
      </Panel>
    </>
  )
}
